var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (digits, undefined) {
// iterate digits
;(function(){
  var $$obj = digits;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var digit = $$obj[$index];

buf.push("<span" + (jade.attr("style", ([
      "opacity: " + (_.isNumber(digit.opacity) ? digit.opacity : 1) + "",
      "transform: translate3d(" + (digit.x || 0) + "px, " + (digit.y || 0) + "px, 0)"
    ]).join(";"), true, false)) + " class=\"digit\">" + (jade.escape(null == (jade_interp = digit.text) ? "" : jade_interp)) + "</span>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var digit = $$obj[$index];

buf.push("<span" + (jade.attr("style", ([
      "opacity: " + (_.isNumber(digit.opacity) ? digit.opacity : 1) + "",
      "transform: translate3d(" + (digit.x || 0) + "px, " + (digit.y || 0) + "px, 0)"
    ]).join(";"), true, false)) + " class=\"digit\">" + (jade.escape(null == (jade_interp = digit.text) ? "" : jade_interp)) + "</span>");
    }

  }
}).call(this);
}.call(this,"digits" in locals_for_with?locals_for_with.digits:typeof digits!=="undefined"?digits:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}